import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const client = new ApiClient(API_NAME)

/**
 * 一問一答系API
 */
export default {
  /**
   * 一問一答リストを取得する
   * @param {number} businessId 案件ID
   * @returns {Promise<any>} レスポンス
   */
  dialogs(businessId) {
    return client.get(`/business/${businessId}/dialog`)
  },

  /**
   * 一問一答の質問・回答内容を取得する
   * @param {number} businessId 案件ID
   * @param {number} dialogId 一問一答ID
   * @returns {Promise<any>} レスポンス
   */
  questions(businessId, dialogId) {
    return client.get(`/business/${businessId}/dialog/${dialogId}/question`)
  },

  /**
   * 一問一答の回答を登録・更新する
   * @param {number} businessId 案件ID
   * @param {number} questionId 質問ID
   * @param {object} data 回答データ
   * @returns {Promise<any>} レスポンス
   */
  answer(businessId, questionId, data) {
    const url = `/business/${businessId}/question/${questionId}/answer`
    return client.put(url, data)
  },

  /**
   * 一問一答のロックを更新する
   * @param {number} businessId 案件ID
   * @param {object} data ロック対象データ
   * @returns {Promise<any>} レスポンス
   */
  lock(businessId, data) {
    return client.put(`/business/${businessId}/dialog/lock`, data)
  }
}
